import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Hero from "../components/sections/Hero";
import Problem from "../components/sections/Problem";
import Handoff from "../components/sections/Handoff";
import Difference from "../components/sections/Difference";
import Pricing from "../components/sections/Pricing";
import Fit from "../components/sections/Fit";
import FAQ from "../components/sections/FAQ";
import Contact from "../components/sections/Contact";

export default function Home() {
  return (
    <div className="bg-cream">
      <Header />
      <main>
        <Hero />
        <Problem />
        <Handoff />
        <Difference />
        <Pricing />
        <Fit />
        <FAQ />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
